//@ts-check
import React from 'react';
/**@type {import('data/types').DataType<import('./types').PublicLinkModel>} */

var APP_DATA_TYPE = {
  data: {
    itemUrl: '/backend/publiclink?id={id}',
    dataKey: 'publicLinks',
    idKeyProp: 'PublicId'
  },
  placeholders: {
    label: function label(data) {
      return data.PublicId;
    },
    type: function type() {
      return 'public link';
    },
    icon: function icon() {
      return 'link';
    },
    name: function name(data) {
      return data.Url;
    }
  },
  thumbnail: {
    url: function url() {
      return '';
    },
    text: function text(data) {
      return data.PublicId;
    },
    icon: function icon() {
      return 'link';
    }
  },
  contextMenu: []
};
export default APP_DATA_TYPE;